// components/BannerSoloLectura.js — F7/F9. Franja de aviso sobre el estado de la tienda activa.
// Se muestra arriba del contenido para que el usuario SEPA, antes de tocar nada, en qué estado
// está su tienda. Color de estado por token (sin hex).
//
// PRIORIDAD (una sola franja, la más urgente): suspendida > desconectada > fin de prueba >
// solo lectura. Lo urgente (cuenta cortada / app desinstalada) gana sobre lo persistente
// (read-only) y sobre lo informativo (trial por vencer).
import React from 'react';
import { Lock, PlugZap, AlertTriangle, Clock, LifeBuoy } from 'lucide-react';
import {
  MENSAJE_SOLO_LECTURA, MENSAJE_DESCONECTADA, MENSAJE_SUSPENDIDA, mensajeFinPrueba, mensajeSoporte,
} from '../utils/soloLectura';
import './BannerSoloLectura.css';

// La franja de SOPORTE (superadmin viendo otra tienda) es independiente y SIEMPRE visible mientras
// dure — se apila ARRIBA de la franja de estado (que igual aplica: p. ej. la tienda es read-only).
function FranjaEstado({ activo, desconectada, suspendida, finPrueba }) {
  if (suspendida) {
    return (
      <div className="banner-solo-lectura banner-desconectada" role="alert">
        <AlertTriangle size={15} aria-hidden="true" />
        <span>{MENSAJE_SUSPENDIDA}</span>
      </div>
    );
  }
  if (desconectada) {
    return (
      <div className="banner-solo-lectura banner-desconectada" role="alert">
        <PlugZap size={15} aria-hidden="true" />
        <span>{MENSAJE_DESCONECTADA}</span>
      </div>
    );
  }
  if (finPrueba) {
    return (
      <div className="banner-solo-lectura" role="status">
        <Clock size={15} aria-hidden="true" />
        <span>{mensajeFinPrueba(finPrueba)}</span>
      </div>
    );
  }
  if (!activo) return null;
  return (
    <div className="banner-solo-lectura" role="status">
      <Lock size={15} aria-hidden="true" />
      <span>{MENSAJE_SOLO_LECTURA}</span>
    </div>
  );
}

export default function BannerSoloLectura({ activo, desconectada, suspendida, finPrueba, soporte }) {
  return (
    <>
      {soporte ? (
        <div className="banner-solo-lectura banner-soporte" role="status">
          <LifeBuoy size={15} aria-hidden="true" />
          <span>{mensajeSoporte(soporte)}</span>
        </div>
      ) : null}
      <FranjaEstado activo={activo} desconectada={desconectada} suspendida={suspendida} finPrueba={finPrueba} />
    </>
  );
}
